export default __webpack_public_path__ + "static/media/spinner.9aff4d93.png";